export default (key = 'resolveProduct') => {
  const { fetch } = useAgsRpc(key, 'resolveProduct')
  return {
    resolve: async (term: string) => {
      return await fetch({ term })
    },
  }
}
